/**
 * 场景 baseClass 统一判断
 *
 * world — 野外大地图（WorldScene / 分块）
 * town  — 城镇、建筑室内
 * cave  — 洞穴 / 副本
 *
 * 兼容旧数据：baseClass 为 world 且 sceneKey 不是 WorldScene 时，仍视为 town。
 */

export const SCENE_BASE_CLASS = {
    WORLD: 'world',
    TOWN: 'town',
    CAVE: 'cave'
};

/**
 * @param {Object|null|undefined} sceneConfig
 * @returns {string}
 */
export function getBaseClass(sceneConfig) {
    return sceneConfig?.baseClass || SCENE_BASE_CLASS.WORLD;
}

/**
 * @param {Object|null|undefined} sceneConfig
 * @returns {boolean}
 */
export function isCave(sceneConfig) {
    return getBaseClass(sceneConfig) === SCENE_BASE_CLASS.CAVE;
}

/**
 * @param {Object|null|undefined} sceneConfig
 * @param {string} [sceneKey]
 * @returns {boolean}
 */
export function isTown(sceneConfig, sceneKey = '') {
    const baseClass = getBaseClass(sceneConfig);
    if (baseClass === SCENE_BASE_CLASS.TOWN) return true;
    if (baseClass === SCENE_BASE_CLASS.CAVE) return false;
    // 旧格式兼容
    return baseClass === SCENE_BASE_CLASS.WORLD && sceneKey !== '' && sceneKey !== 'WorldScene';
}

/**
 * @param {Object|null|undefined} sceneConfig
 * @param {string} [sceneKey]
 * @returns {boolean}
 */
export function isOverworld(sceneConfig, sceneKey = '') {
    const baseClass = getBaseClass(sceneConfig);
    if (baseClass !== SCENE_BASE_CLASS.WORLD) return false;
    return sceneKey === '' || sceneKey === 'WorldScene';
}

/**
 * 遇敌区域（城镇返回 null，表示无野外遇敌表）
 * @param {Object|null|undefined} sceneConfig
 * @param {string} [sceneKey]
 * @returns {'cave'|'world'|null}
 */
export function getEncounterArea(sceneConfig, sceneKey = '') {
    if (isCave(sceneConfig)) return 'cave';
    if (isOverworld(sceneConfig, sceneKey)) return 'world';
    return null;
}

export default {
    SCENE_BASE_CLASS,
    getBaseClass,
    isCave,
    isTown,
    isOverworld,
    getEncounterArea
};
